// graph/roleAllocation/queries.js

import { gql } from "graphql-request";

export const READ_ROLE_ALLOCATION_BOARD = gql`
  query ReadRoleAllocationBoard($input: ReadRoleAllocationBoardInput!) {
    readRoleAllocationBoard(input: $input) {
      tenantId
      departmentId

      departments {
        id
        tenantId
        name
        description
      }

      roles {
        role {
          id
          name
          departmentId
        }

        peopleCount
        sopCount

        peopleCards {
          assignment {
            id
            tenantUserId
            tenantRoleId
            isPrimary
          }

          tenantUser {
            id
            userId
          }

          tenantRole {
            id
            name
          }

          isPrimary
          displayName
        }

        sopCards {
          assignment {
            id
            projectId
            tenantRoleId
          }

          sop {
            id
            title
            isSOPTemplate
          }

          tenantRole {
            id
            name
          }
        }
      }
    }
  }
`;